var $ = require("@alife/alpha-jquery/jquery");
var Widget = require("@alife/alpha-widget/widget");
var AtmPlugin = require("./atm-plugin");
var Domdot = require("@alife/alpha-domdot/domdot");
var isAlibaba = !!location.hostname.match(/alibaba\.com/);
var Xman = require("@alife/alpha-xman/xpopup");
var Cookie = require("@alife/alpha-cookie/cookie");
var MarketSugguestionn = require("@alife/scc-initiative-sugguestion");

var AUTO_ASSIGN_URL = "https://onetalk.alibaba.com/message/distributeChat.htm";
// 日志打点
function logger(url) {
  var pageId = window.dmtrack_pageid || "";

  if (typeof url != "undefined" && url) {
    var name = "atm_log_" + new Date().getTime();
    var img = new Image();

    // 直接使用new Image(), 生成的对象可能会因为内存回收而被删除, 导致请求无法正常发出
    // 这里借用window对象来保证img对象不会被销毁
    window[name] = img;
    img.onload = function () {
      try {
        window[name] = null;
        delete window[n];
      } catch (e) {
        // empty
      }

      this.onload = null;
    };
    img.src = url + "&pageid=" + pageId;
  }
}

var AliTalkUnit = Widget.extend({
  attrs: {
    webatmReady: -19,
    online: "OFFLINE",
    usrText: ["Chat Now!", "Leave Messages", "I'm Away", "I'm Busy"],
    usrTipText: ["Chat with me", "Please Leave a Message", "Please Leave a Message", "Please Leave a Message"],
    usrCls: ["atm-online", "atm-grey", "atm-away", "atm-busy"],
  },
  events: {
    click: "startTalk",
  },
  parseElement: function () {
    var self = this;
    self.checkAtmReady();

    var status = self.get("status");
    var map = {
      LEISURE: 0,
      OFFLINE: 1,
      LEAVE: 2,
      BUSY: 3,
    };

    if (!(status in map)) {
      status = "OFFLINE";
    }

    var index = map[status];
    var renderCallback = self.get("renderCallback");
    var params = {
      status: status,
      statusCode: self.get("statusCode"),
      class: self.get("usrCls")[index],
      title: self.get("usrTipText")[index],
      text: self.get("usrText")[index],
    };

    // 调用renderCallback回调, 此Callback允许用户对this.element进行定制
    if (typeof renderCallback === "function") {
      renderCallback.call(self, params);
    } else {
      var html = $('<div class="alitalk-unit alitalk-' + self.get("uiType") + '">loading<div>');

      html.attr("data-status", params.status).addClass(params["class"]).attr("title", params.title).text(params.text);

      self.element.empty().append(html);
    }
  },
  render: function () {
    // 由于Widget默认的渲染逻辑是将this.element插入到parentNode中, 但这对于alitalk并不合理, 因为alitalk一般就是一个a标签,
    // 向里面插入this.element并绑定事件导致点击在a标签上无效, 只在this.element上有效. 这里重写render以阻止调用父类的插入逻辑

    return self;
  },
  checkAtmReady: function () {
    var self = this;

    setTimeout(function () {
      if (window.WebATM && window.WebATM.Main) {
        self.set("webatmReady", 1);
      } else {
        var count = self.get("webatmReady");
        if (count < 0) {
          self.set("webatmReady", ++count);
          self.checkAtmReady();
        }
      }
    }, 500);
  },
  setup: function () {
    if (this.get("isWeblite")) {
      var position = this.get("position") || {};
      this.webliteData = {
        webliteConfig: {
          activeLoginIdEncrypt: this.get("contactIdEncrypt"),
          productId: this.get("productId"),
          sceneType: this.get("sceneType"),
          lazyInit: this.get("disable"),
          attrs: {
            bizType: this.get("bizType"),
            bizId: this.get("bizId"),
            action: this.get("action"),
            source: this.get("source"),
            inquiryUrl: this.get("inquiryurl"),
          },
        },
        type: "weblite:init",
        refer: location.href,
        pageId: window.dmtrack_pageid || "",
        position: {
          right: position.right || "60px",
          bottom: position.bottom || 0,
        },
      };
      // 是否初始化后展示常驻入口
      if (!this.get("disable")) {
        this.initWeblite();
      }
    }
  },
  changeContact: function () {
    var self = this;
    return new Promise(function (resolve, reject) {
      var config = self.webliteData.webliteConfig;
      $.ajax({
        type: "POST",
        url: "https://onetalk.alibaba.com/csrf/getToken.htm",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
      })
        .done(function (result) {
          $.ajax({
            type: "POST",
            url: AUTO_ASSIGN_URL,
            dataType: "json",
            xhrFields: {
              withCredentials: true,
            },
            data: {
              params: JSON.stringify({
                contactLoginIdEncrypt: config.activeLoginIdEncrypt,
                bizType: self.get("bizType"),
                bizId: self.get("bizId").toString(),
              }),
              _csrf: result.token,
            },

            success: function (ret) {
              resolve(ret.data);
            },
            error: function (err) {
              reject(err);
            },
          });
        })
        .fail(function () {
          reject();
        });
    });
  },
  initMarket: function () {
    // 防止一个页面部署了多个alitalk后出现多个营销弹窗
    if (!window.__MARKET_SUGGESTION) {
      var self = this;
      var marketSuggest = (window.__MARKET_SUGGESTION = new MarketSugguestionn({
        contactId: this.get("contactIdEncrypt"),
        contactName: this.get("contactName"),
        contactImg: this.get("contactImg"),
        productId: this.get("productId"),
        isWeblite: this.get("isWeblite"),
      }));
      marketSuggest.on("MARKET_CHAT", function (data) {
        self.webliteIframe.contentWindow.postMessage(JSON.stringify({ type: "weblite:market", marketData: data }), self.domain);
      });
    }
  },
  initDomain: function () {
    var origin = "onetalk.alibaba.com";
    this.domain = location.protocol + "//" + origin;
  },
  initWeblite: function (selectContact) {
    var self = this;
    this.initDomain();
    // 上面逻辑之所以在最前面, 是为了防止已经初始化过weblite iframe后, 拿不到domain值
    if (window.__WEBLITE_IFRAME__) {
      return;
    }
    if (selectContact) {
      this.webliteData.type = "weblite:selectContact";
    }
    var domain = this.domain;
    var INIT_WIDTH = 245;
    var INIT_HEIGHT = 50;
    var right = parseInt(this.webliteData.position.right);
    var bottom = parseInt(this.webliteData.position.bottom);
    var iframe = (this.webliteIframe = window.__WEBLITE_IFRAME__ = document.createElement("iframe"));
    iframe.setAttribute("src", domain + "/message/weblite.htm");
    iframe.setAttribute("id", "#weblite-iframe");
    iframe.setAttribute("frameborder", 0);
    iframe.setAttribute("allow", "microphone;camera;midi;encrypted-media;");
    var styles = "z-index: 999; position: fixed; right:" + right + "px; bottom: " + bottom + "px;";
    styles += "width" + INIT_WIDTH + "px";
    styles += "height" + INIT_HEIGHT + "px";
    styles += "box-shadow: -4px -4px 14px rgba(0,0,0,.1)";
    iframe.setAttribute("style", styles);
    document.body.appendChild(iframe);
    iframe.addEventListener("load", function () {
      iframe.contentWindow.postMessage(JSON.stringify(self.webliteData), domain);
      // 主动营销放这里是为了确保触发营销时已经初始化
      self.initMarket();
    });
    window.addEventListener(
      "message",
      function (event) {
        if (event.origin !== domain) {
          return;
        }
        var data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {}
        if (data.type === "CHANGE_SIZE") {
          iframe.style.width = data.width + "px";
          iframe.style.height = data.height + "px";
        } else if (data.type === "LOGIN") {
          if (!self.XMAN) {
            self.XMAN = new Xman({
              forcePopup: true,
              onSuccess: function () {
                iframe.contentWindow.postMessage(JSON.stringify({ type: "weblite:reload" }), self.domain);
              },
            });
          }
          self.XMAN.show();
        }

        if (data.type === "meetingChange") {
          var width = data.width,
            height = data.height;
          if (data.showType !== "show") {
            width = data.width + "px";
            height = data.height + "px";
          }
          iframe.style.width = width; // vw宽度不能通过iframe.width设置
          iframe.style.height = height;
        }
      },
      false
    );
  },
  genUrlQuery: function (params, sign, raw) {
    var items = [];
    var name, value;

    for (name in params) {
      value = params[name] || "";

      if (!raw) {
        value = encodeURIComponent(value);
      }

      items.push(name + "=" + value);
    }

    return items.join(sign || "&");
  },
  startTalk: function (e) {
    e.preventDefault();

    var self = this;
    var status = self.get("status");

    // 还未初始化完成
    if (self.element.data("status") == "LOADING") {
      return false;
    }
    //TODO 临时处理判断wholesale的问题
    if (this.element.data("market") === true) {
      window.PRODUCT_TYPE = "ws";
    }
    // 点击chatNow打点
    Domdot.dotstat(2415);

    var from = self.get("from") || 1;
    var enMemberId = self.get("enMemberId");
    var productId = self.get("productId") || "";
    var enProductId = self.get("enProductId") || "";
    var pageid = window.dmtrack_pageid || "";
    var sceneType = self.get("sceneType");

    // 增加最终回调，用于
    var domdotCb = self.get("domdotCallback");
    if (typeof domdotCb == "function") {
      var result = domdotCb.call(self, {
        enMemberId: enMemberId,
        from: from,
        productId: productId,
        userStatus: status,
        pageid: pageid,
      });
    }

    // 如果定义的在线/离线回调, 就执行
    if (status === "OFFLINE") {
      // 旺旺不在线打点
      Domdot.dotstat(15469);

      /*@debug
                 console.log('旺旺不在线:' + 15469);
                 */

      // 自定义了离线回调
      var offlineCb = self.get("offlineCallback");

      if (typeof offlineCb == "function") {
        // 为后续回调绑定 self 上下文
        var result = offlineCb.call(self, {
          enMemberId: enMemberId,
          from: from,
          productId: productId,
          userStatus: status,
          pageid: pageid,
        });

        // 如果返回值不为false, 就不再走下面的WebATM/ATM流程了
        if (result !== false) {
          return;
        }
      }
    } else {
      // 自定义了在线回调
      var onlineCb = self.get("onlineCallback");

      if (typeof onlineCb == "function") {
        // 为后续回调绑定 self 上下文
        var result = onlineCb.call(self, {
          enMemberId: enMemberId,
          from: from,
          productId: productId,
          userStatus: status,
          pageid: pageid,
        });

        // 如果返回值不为false, 就不再走下面的WebATM/ATM流程了
        if (result !== false) {
          return;
        }
      }
    }

    //1_GLP:代表detail页面get latest price打点来源;1_ATM:代表detail页面主表单打点来源;1_ZTC:代表直通车页面打点来源
    //2_ATM_DETAIL:代表minisite-product页面主表单打点来源
    //1_SO_GLP:代表商家在线detail页面get latest price打点来源;1_SO_ATM:代表商家在线 detail页面打点来源;
    //2_P_SO_ATM:代表商家在线minisite-product页面打点来源
    //2_WB_DETAIL：代表旺遍天下独立detail页面打点来源
    var fromProductRegExp = /^(?:1_GLP|1_ATM|1_ZTC|1_SO_GLP|1_SO_ATM|2_P_SO_ATM|2_WB_DETAIL|2_ATM_DETAIL|1_GLOBAL_ATM)$/;
    var fromProduct = "1";

    // 已经加载了插件, 如果加载了, 就打开客户端
    if (AtmPlugin.isReady()) {
      // 打开客户端量的打点
      var gokey = self.genUrlQuery({
        type: "client",
        STEP: "CLICK",
        from: from,
        id: productId,
        refer: window.top.location.href.replace(/&/gi, "$"),
        time: new Date().getTime(),
      });
      logger(location.protocol + "//gm.mmstat.com/sc.migrate.atm?gmkey=&logtype=2&gokey=" + encodeURIComponent(gokey));
      // 弹出ATM对话框打点
      Domdot.dotstat(2417);

      /*@debug
                 console.log('弹出ATM对话框打点:' + 2417);
                 */

      var params = {};

      if (from == fromProduct || fromProductRegExp.test(from)) {
        params["gid"] = productId;
        params["id"] = enMemberId;
      }

      // 在mac系统的chrome浏览器中#导致无法调用旺旺客户端,而url2参数在mac版旺旺中未做处理，所以可以暂时去除。
      if (navigator.platform.indexOf("Mac") < 0) {
        var extraOne = self.genUrlQuery(
          {
            zparam: productId + "_" + from,
            pageid: pageid,
            id: productId,
            refer: window.top.location.href.replace(/&/gi, "$"),
            time: new Date().getTime(),
          },
          "#",
          true
        );

        params["url2"] = location.protocol + "//atmgateway-client.alibaba.com/atmgateway/http/feedbackfromalitalk.do?" + extraOne;
      }

      // TM自动分流
      if (self.get("bizType")) {
        self
          .changeContact()
          .then(function (data) {
            enMemberId = data.receiverLoginIdEncrypt;
            AtmPlugin.chatTo(enMemberId, self.genUrlQuery(params));
          })
          .catch(function (err) {
            // 兜底走原来的联系人
            AtmPlugin.chatTo(enMemberId, self.genUrlQuery(params));
          });
      } else {
        AtmPlugin.chatTo(enMemberId, self.genUrlQuery(params));
      }

      /*@debug
                console.log('调用ATM插件(参数):' + self.genUrlQuery(params));
                */
    } else {
      // 弹出webatm对话框打点
      Domdot.dotstat(2418);

      /*@debug
                 console.log('弹出webatm对话框:' + 2418);
                 */

      var gokey = self.genUrlQuery({
        STEP: "webclick",
        from: from,
        id: productId,
        refer: window.top.location.href.replace(/&/gi, "$"),
        time: new Date().getTime(),
      });
      logger(location.protocol + "//gm.mmstat.com/sc.migrate.atm?gmkey=&logtype=2&gokey=" + encodeURIComponent(gokey));

      // =========== 新版weblite逻辑 ==============
      if (this.get("isWeblite")) {
        var webliteIframe = document.getElementById("#weblite-iframe");
        this.webliteData.type = "weblite:selectContact";
        // fix bug. 在list场景, alpha-alitalk存在多个, 需要在点击的时候确认当前是哪个用户
        this.webliteData.activeLoginIdEncrypt = this.get("contactIdEncrypt");
        var isLoginCookie = Cookie.get("xman_us_t");
        var isLogin = isLoginCookie && isLoginCookie.indexOf("sign=y") !== -1;
        if (!isLogin) {
          if (!this.XMAN) {
            this.XMAN = new Xman({
              forcePopup: true,
              onSuccess: function () {
                if (!webliteIframe) {
                  self.initWeblite(true);
                } else {
                  webliteIframe.contentWindow.postMessage(JSON.stringify(self.webliteData), self.domain);
                }
              },
            });
          }
          this.XMAN.show();
          return;
        }

        if (!webliteIframe) {
          this.initWeblite(true);
        } else {
          if (!self.domain) {
            self.initDomain();
          }
          webliteIframe.contentWindow.postMessage(JSON.stringify(self.webliteData), self.domain);
        }

        return;
      }

      // web旺旺还未加载好
      if (!isAlibaba || self.get("webatmReady") <= 0) {
        var url =
          location.protocol +
          "//webatm.alibaba.com/start_web_atm.htm?" +
          self.genUrlQuery({
            enemberId: enMemberId,
            pid: productId,
            eid: enProductId,
            from: from,
            sceneType: sceneType,
            refer: window.top.location.href.replace(/&/gi, "$"),
            pageid: pageid,
          });

        var feature = "height=700,width=800,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no,top=50,left=200";

        window.open(url, "aliWebATM", feature);

        return;
      } else {
        // 使用加载好的webATM聊天
        window.WebATM.Main.chatTo(enMemberId, {
          pid: productId,
          eid: enProductId,
          from: from,
          sceneType: sceneType,
        });
      }
    }
  },
});

module.exports = AliTalkUnit;
